
































































































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';
import { GEnum } from '@/constants/enum.defination';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import GTemplateTopicForm from '@/components/GTopicForm.vue';
import GSurveyAnalyzeFilter from '@/views/GSurveyAnalyze/GSurveyAnalyzeFilter.vue';
import GSurveyChart from '@/views/GSurveyAnalyze/GSurveyChart.vue';
import GStatisticsChart from '@/views/GStatistics/GStatisticsChart.vue';
import { eventGiftCourseModule } from '@/store/modules/frames/event-gift-course.module';
import GLoading from '@/components/GLoading.vue';
import GSurveyAggressiveEntry from './GSurveyAggressiveEntry.vue';
import GSurveyAnalyzeCompetencyChart from './GSurveyAnalyzeCompetencyChart.vue';
import GSurveyAnalyzeCompetencyTable from './GSurveyAnalyzeCompetencyTable.vue';
import GCompetencyLabel from '@/components/GCompetencyLabel.vue';
import GStudentRecordCompetencyScoreTransition from '@/views/GStudentRecord/GStudentRecordCompetencyScoreTransition.vue';
import GStatisticsBoxplotSubTableInfoTable from '@/components/GStatisticsBoxplotSubTableInfoTable.vue';
import { CompetencyScoreCompare, CompetencyScoreRanking } from '@/models/jgrow/competency-score-compare';
import GSurveyCompetencyPlusGrowthAnalyze from './GSurveyCompetencyPlusGrowthAnalyze.vue';

@Component({
  name: 'GSurveyAnalyzeCompetency',
  components: {
    GLoading,
    GSurveyChart,
    GSurveyAnalyzeFilter,
    GTemplateTopicForm,
    GTitleBar,
    GCustomBreadCrumb,
    GStatisticsChart,
    GSurveyAggressiveEntry,
    GSurveyAnalyzeCompetencyChart,
    GSurveyAnalyzeCompetencyTable,
    GCompetencyLabel,
    GStudentRecordCompetencyScoreTransition,
    GStatisticsBoxplotSubTableInfoTable,
    GSurveyCompetencyPlusGrowthAnalyze,
  },
  computed: {},
  methods: {},
})
export default class GSurveyAnalyzeCompetency extends mixins(GPageBase) {
  created() {}

  async mounted() {}

  get hasData(): boolean {
    return eventGiftCourseModule.hasCompetencyData;
  }

  // 他者評価ランキング（TOP3）と自己評価ランキング（TOP3）のコンピテンシーによってコメントを出し分ける
  // https://i-globalsociety.atlassian.net/wiki/spaces/JGROW/pages/3005514019/TOP3
  competencyRankingComment(): string[] {
    // 他者評価平均値（事前・事後） と 自己評価平均値（事前・事後） 双方にランキング対象が存在しない場合
    if (!this.competencyScoreAvgs.hasRanking && !this.competencySelfScoreAvgs.hasRanking) {
      return ['生徒自身も自己成長を実感できず、周りが変化に気づくレベルの行動変容に至っていない、もしくは他者の変化を観察する機会が少ない可能性があります。','さらなる成長のために、自己成長を意識できるようにすることが必要です。自己評価や他者評価の振り返りにより生徒自身の強みや改善点を考える機会を提供することが重要です。'];
    }
    // 他者評価平均値（事前・事後）にはランキング対象が存在し、自己評価平均値（事前・事後）にランキング対象が存在しない場合
    if (this.competencyScoreAvgs.hasRanking && !this.competencySelfScoreAvgs.hasRanking) {
      return ['周囲の生徒は成長を評価していますが、生徒自身は自己成長を実感できていないようです。','さらなる成長のために、自己成長を意識できるようにすることが必要です。他者評価の結果をもとに自己評価を振り返り、自身の能力や成果を客観的に評価するトレーニング機会を提供することが重要です。'];
    }
    // 他者評価平均値（事前・事後）にはランキング対象が存在せず、自己評価平均値（事前・事後）にランキング対象が存在する場合
    if (!this.competencyScoreAvgs.hasRanking && this.competencySelfScoreAvgs.hasRanking) {
      return ['生徒は自己成長を実感している一方、周りが変化に気づくレベルの行動変容に至っていない、もしくは他者の変化を観察する機会が少ない可能性があります。','さらなる成長のために、周囲の人々との協力や共同プロジェクトの機会を提供し、成長を評価できる機会を増やすことが重要です。'];
    }
    // 他者評価平均値（事前・事後）&& 自己評価平均値（事前・事後）双方にランキング対象（プラス成長）が存在する場合
    if (this.competencyScoreAvgs.hasRanking && this.competencySelfScoreAvgs.hasRanking) {
      // 他者評価ランキング・自己評価ランキングで同じコンピテンシーが存在するか確認
      const duplicated = this.competencyScoreAvgs.ranking.filter((compe: CompetencyScoreCompare) => {
        const found = this.competencySelfScoreAvgs.ranking.find((compeSelf: CompetencyScoreCompare) => {
          if (compe.competency.competencyID === compeSelf.competency.competencyID) return compeSelf;
        });
        if (found) return compe;
      });
      // 重複が存在する場合
      if (duplicated.length > 0) {
        // コンピテンシータイプ（認知系・自己系・他者系・コミュニティ系）による重複を整理
        // コンピテンシーは異なるが、タイプが同じ場合はまとめる
        const types: GEnum.CompetencyType[] = [];
        duplicated.forEach((compe: CompetencyScoreCompare) => {
          if (!types.includes(compe.competency.competencyType)) types.push(compe.competency.competencyType);
        });
        // 重複タイプが複数の場合
        if (types.length > 1) {
          return ['様々な能力において自己の成長を実感され、周囲からもその成長が評価されています。','さらなる成長のために、課題解決に積極的に取り組み、自己の可能性を信じ、他者との関係を築き、組織や社会への貢献を意識した行動の意義を伝え、能力を発揮できる機会を提供することが重要です。'];
        } else {
          // 重複が１つの場合
          switch (types[0]) {
            case GEnum.CompetencyType.Cognitive:
              return ['複数の能力において自己の成長を実感され、周囲からもその成長が評価されています。','特に、問題解決に必要な思考力については、生徒自身が成長を実感し、周囲の人々からも成長が評価されています。今後の成長のためには、さらなるチャレンジ精神を持ち、複雑な課題解決に積極的に取り組む機会の提供が重要となります。'];
            case GEnum.CompetencyType.Self:
              return ['複数の能力において自己の成長を実感され、周囲からもその成長が評価されています。','特に、自分自身を信じる力や自己成長の意欲を持つ力について、生徒自身が成長を実感し、周囲の人々からも成長が評価されています。さらなる成長のために、生徒の自主性を尊重しながらも、彼らの目標達成に向けた取り組みを支援することが重要です。'];
            case GEnum.CompetencyType.Gift:
              return ['複数の能力において自己の成長を実感され、周囲からもその成長が評価されています。','特に、他者との関係性を構築する力について、生徒自身が成長を実感し、周囲の人々からも成長が評価されています。さらなる成長のために、他者との連携やチームワークによって複雑な課題を共に乗り越えるような機会の提供が重要です。'];
            case GEnum.CompetencyType.Community:
              return ['複数の能力において自己の成長を実感され、周囲からもその成長が評価されています。','特に、組織や社会に貢献する力について、生徒自身が成長を実感し、周囲の人々からも成長が評価されています。さらなる成長のために、他の人たちの成長や幸福も考えながら行動することの意義を伝えていくことが重要です。'];
          }
        }
      } else {
        // 重複が存在しない場合
        return ['複数の能力において自己の成長を実感され、周囲からもその成長が評価されていますが、','自己の成長を実感している能力と他者の評価が異なっています。このような異なる評価結果は、新たな学びの機会として捉えることができます。さらなる成長のために、他者とのコミュニケーションやフィードバックにより、生徒の自己理解を深める機会の提供が重要です。'];
      }
    }
    return ['test'];
  }

  get top3Competencies(): CompetencyScoreCompare[] {
    return this.competencyScoreAvgs.ranking;
  }

  get top3CompetenciesSelf(): CompetencyScoreCompare[] {
    return this.competencySelfScoreAvgs.ranking;
  }

  get competencyScoreAvgs(): CompetencyScoreRanking {
    return eventGiftCourseModule.competencyScoreAvgs;
  }

  get competencySelfScoreAvgs(): CompetencyScoreRanking {
    return eventGiftCourseModule.competencySelfScoreAvgs;
  }

  get boxplotSubTableData(): any[] {
    return eventGiftCourseModule.echartService.subTableData;
  }

  get boxplotSubTableColumns(): any[] {
    return eventGiftCourseModule.echartService.subTableColmuns;
  }

  get isDispBoxplotSubTableInfoTable(): boolean {
    return this.boxplotSubTableData.length > 0;
  }

  setDataList() {
    // @ts-ignore
    this.$refs.competencyPlusGrowthAnalyze.setDataList();
  }
}
